import styled, { css } from "styled-components";

export const Link = styled.a`
  position: relative;
  font-size: 14px;
  line-height: 22px;
  transition: .2s ease-in-out;
  ${({ theme }) => css`
    ${theme.media.mobileL} {
     font-size: 1.1rem; 
    }
  `}
  :hover {
    color: #ffe600;
  }
  :active {
    color: #ffb800;
  }
`;